import { useRequest } from 'ahooks';
import { getOrgAndNum } from '@axios/api'
import util from '../../../utils/utils';

function useGetOrgAndNum(){
  const cacheKey = `orgAndNum:${util.getCurrentClientId()}`;
  const { loading, data, run } = useRequest(
    async () => {
      try {
        const resp = await getOrgAndNum();
        return resp?.data
      } catch (error) {
        return [];
      }
    },
    {       
      debounceWait: 50,
      refreshDeps:[],
      retryCount: 1,
      // ✅ 缓存配置：10分钟内复用
      cacheKey,
      staleTime: 10 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
    },
  );

    return {
      orgAndNumLoading:loading,
      orgAndNumData:data,
    }
}

export default useGetOrgAndNum